import { jsx as c, jsxs as r, Fragment as m } from "react/jsx-runtime";
import { S as s } from "../../../vendor--aJiswR_.js";
import "react";
import "../../../theme/spacing.js";
import { omitStyleRenderProps as i } from "../../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as p } from "../../BaseIcon/index.js";
import '../../../assets/index39.css';const a = "_item_yznwc_1", _ = "_content_yznwc_44", h = "_chevron_yznwc_48", n = {
  item: a,
  content: _,
  chevron: h
}, b = ({ children: o, ...e }) => /* @__PURE__ */ c(s, { ...i(e), className: n.item, children: (t) => /* @__PURE__ */ r(m, { children: [
  /* @__PURE__ */ c("div", { className: n.content, children: typeof o == "function" ? o(t) : o }),
  t.hasSubmenu && /* @__PURE__ */ c(p, { color: "moon", icon: "chevron-next", className: n.chevron })
] }) });
export {
  b as Item
};
//# sourceMappingURL=index.js.map
